import { apiService } from '@app/services/api-service';
import {
  AdminDashboardFunnelBandOutDto,
  AdminDashboardMoneyBandOutDto,
  AdminDashboardQrCodesOutDto,
  AdminDashboardTilesOutDto,
  AdminDashboardTodayOutDto,
  AdminDashboardUpcomingOutDto,
} from '@app/swagger-types';

// admin-dashboard-opdracht.md - het lege dashboardscherm in het adminpaneel. Band 4 is always
// "now"/a fixed window (no from/to); band 1's tiles, band 1b, band 2's trend/source charts, and
// band 3 respect the top-level period selector - see AdminDashboardFacadeImpl's own javadoc.
export abstract class AdminDashboardApi {
  static async getTiles(from: string, to: string) {
    const { data } = await apiService.get<AdminDashboardTilesOutDto>(`/private/admin/dashboard/tiles`, {
      params: { from, to },
    });
    return data;
  }

  static async getUpcoming() {
    const { data } = await apiService.get<AdminDashboardUpcomingOutDto>(`/private/admin/dashboard/upcoming`);
    return data;
  }

  static async getQrCodes(from: string, to: string) {
    const { data } = await apiService.get<AdminDashboardQrCodesOutDto>(`/private/admin/dashboard/qr-codes`, {
      params: { from, to },
    });
    return data;
  }

  static async getToday() {
    const { data } = await apiService.get<AdminDashboardTodayOutDto>(`/private/admin/dashboard/today`);
    return data;
  }

  static async getFunnel(from: string, to: string) {
    const { data } = await apiService.get<AdminDashboardFunnelBandOutDto>(`/private/admin/dashboard/funnel`, {
      params: { from, to },
    });
    return data;
  }

  static async getMoney(from: string, to: string) {
    const { data } = await apiService.get<AdminDashboardMoneyBandOutDto>(`/private/admin/dashboard/money`, {
      params: { from, to },
    });
    return data;
  }
}
